import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

interface DisclaimerProps {
  title?: string;
}

export const Disclaimer = ({ title }: DisclaimerProps) => {
  const { t } = useTranslation(I18nNamespace.conversation);
  return (
    <Typography
      textAlign="center"
      color="textDisabled"
      variant="caption"
      paddingTop={2}
      paddingBottom={1}
      sx={{ fontSize: 10 }}
    >
      {title ?? t('Disclaimer')}
    </Typography>
  );
};
